import React from 'react';

class CreateChannel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: !props.width ? 16 : props.width,
      height: !props.height ? 21.333 : props.height,
      color: !props.color ? '#c6c6c6' : props.color,
    };
  }

  render() {
    return (
      <svg
        className={this.props.className}
        xmlns="http://www.w3.org/2000/svg"
        width={this.state.width}
        height={this.state.height}
        viewBox={`0 0 ${this.state.width} ${this.state.height}`}>
        <path
          id="ghost-solid"
          d="M7.754.005A8.222,8.222,0,0,0,0,8.337v11a.666.666,0,0,0,1.138.471l1.038-.772a.667.667,0,0,1,.9.092l1.79,2.015a.667.667,0,0,0,.943,0l1.7-1.91a.666.666,0,0,1,1,0l1.7,1.91a.667.667,0,0,0,.943,0l1.79-2.015a.666.666,0,0,1,.9-.092l1.038.772A.667.667,0,0,0,16,19.333V8A8,8,0,0,0,7.754.005ZM5.333,9.335A1.333,1.333,0,1,1,6.667,8,1.333,1.333,0,0,1,5.333,9.335Zm5.333,0A1.333,1.333,0,1,1,12,8,1.333,1.333,0,0,1,10.667,9.335Z"
          transform="translate(0 -0.001)"
          fill={this.state.color}
        />
      </svg>
    );
  }
}

export default CreateChannel;
